<template>
    <v-dialog v-model="dialog" persistent>
      <v-card light>
        <v-card-text>
          <v-text-field
            v-model="val"
            type="text"
            name="input-2"
            :label="labelText"
            light
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click.native="confirm(false)">{{negativeText}}</v-btn>
          <v-btn color="green darken-1" flat @click.native="confirm(true)">{{positiveText}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'simple-text-input',
    props: {

        default: {required: false, default: ""},
        dialog: { required: true, default: false },
        labelText: { required: false, default: "" },
        positiveText: {required: false, default: "Aceptar" },
        negativeText: {required: false, default: "Cancelar" }
    },
    data() {
      return {
        val: 1
      }
    },
    watch:{
      default(newVal, oldVal){
        this.val = newVal
      },
      dialog(newVal, oldVal){
        console.log("dialog",newVal,oldVal,this.default)

        this.val = this.default

      }
    },
    methods: {
        confirm(response) {
            this.$emit('confirm', response, this.val)
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/helpers/modals/SimpleTextInput.vue